module.exports = __webpack_public_path__ + "static/img/img-hotel-350x232.738ba4ac.png";